export default function WhyTrainingMatters() {
  const stats = [
    {
      icon: 'ri-line-chart-line',
      value: '+37%',
      label: 'рост эффективности',
      description: 'Компании с системным обучением показывают рост операционной эффективности',
    },
    {
      icon: 'ri-speed-up-line',
      value: '+24%',
      label: 'рост производительности',
      description: 'Производительность сотрудников увеличивается после структурированного обучения',
    },
    {
      icon: 'ri-heart-pulse-line',
      value: '+41%',
      label: 'рост вовлеченности',
      description: 'Вовлеченность персонала растет, когда компания инвестирует в развитие',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      value: '+26%',
      label: 'рост прибыли',
      description: 'Обученный отдел продаж и эффективные руководители напрямую влияют на прибыль',
    },
    {
      icon: 'ri-user-received-line',
      value: '−34%',
      label: 'снижение текучести',
      description: 'Сотрудники реже уходят, когда видят перспективы роста и развития',
    },
    {
      icon: 'ri-timer-line',
      value: '−50%',
      label: 'ускорение адаптации',
      description: 'Новые сотрудники выходят на плановые показатели вдвое быстрее',
    },
  ];

  return (
    <section id="why-matters" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Почему корпоративное обучение стало одним из главных факторов роста бизнеса
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Исследования подтверждают: компании, инвестирующие в системное обучение персонала, опережают конкурентов по ключевым показателям. Вот что говорят цифры.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {stats.map((item) => (
            <div key={item.label} className="group bg-gray-50 rounded-2xl p-8 hover:bg-gray-100 transition-all duration-300 border border-gray-100">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl text-teal-600`}></i>
              </div>
              <div className="text-4xl font-extrabold text-teal-600 mb-2">{item.value}</div>
              <div className="text-lg font-semibold text-gray-900 mb-3">{item.label}</div>
              <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}